<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <v-autocomplete
          ref="controlFocoSelectCliente"
          :label="iLabel"
          v-model="itemActivo.Id_Cliente"
          :items="items"
          item-value="Id_Cliente"
          item-text="NombreRazonSocialCuit"
          :search-input.sync="palabraBuscada"
          :rules="rules"
          :readonly="readonly"
          :loading="loading"
          outlined
          hide-details
          clearable
          auto-select-first
          @change="buscar"
          @keyup.enter="listar"
          @click:clear="inicializar"
          @click:append="listar"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title
                v-text="item.NombreRazonSocialCuit"
              ></v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:no-data>
            <v-icon small>info</v-icon>
            <small>
              Ingrese el texto a buscar y presione
              <strong>ENTER</strong>
            </small>
          </template>
          <template v-slot:progress>
            <v-progress-circular
              color="blue"
              indeterminate
            ></v-progress-circular>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <v-card-text>
            <small>
              {{ itemActivo.NombreTipoIva }} /
              {{ iNombreTipoVenta }}
            </small>
            <span v-if="itemActivo.Id_Cliente != 0">
              <small>
                <strong>
                  Saldo Actual {{ itemActivo.SaldoActual | esMoneda }}
                </strong>
              </small>
              <small>
                / Disponible
                {{ (itemActivo.Limite - itemActivo.SaldoActual) | esMoneda
                }}<br />
              </small>
              <small>
                {{ itemActivo.Direccion }}, {{ itemActivo.NombreLocalidad }} -
                Tel. {{ itemActivo.Telefono }}, {{ itemActivo.Celular }} - Email
                {{ itemActivo.Email }}
              </small>
            </span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectCliente",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      itemVacio: {
        Id_Cliente: 0,
        Direccion: null,
        NombreLocalidad: null,
        Telefono: null,
        Celular: null,
        Email: null,
        Id_TipoIva: "F",
        NombreTipoIva: null,
        Id_TipoVenta: "I",
        NombreTipoVenta: null,
        AlicuotaPercepcionIb: 0,
        Limite: 0,
        SaldoActual: 0
      },
      itemActivo: {},
      items: [],
      comprobantes: [],
      palabraBuscada: "",
      loading: false
    };
  },
  computed: {
    iLabel() {
      return this.rules == null ? "Cliente" : "Cliente*";
    },
    iNombreTipoVenta() {
      return this.itemActivo.AlicuotaPercepcionIb != undefined &&
        this.itemActivo.AlicuotaPercepcionIb > 0
        ? this.itemActivo.NombreTipoVenta +
            " (" +
            this.itemActivo.AlicuotaPercepcionIb +
            "%)"
        : this.itemActivo.NombreTipoVenta;
    }
  },
  watch: {
    model(valor) {
      if (valor && valor != this.itemActivo.Id_Cliente) this.cargar(valor);
    }
  },
  created() {
    eventBus.$on("inicializarSelectCliente", this.inicializar);
    eventBus.$on("setearFocoSelectCliente", this.setearFoco);
    this.inicializar();
  },
  beforeDestroy() {
    eventBus.$off("inicializarSelectCliente", this.inicializar);
    eventBus.$off("setearFocoSelectCliente", this.setearFoco);
  },
  methods: {
    inicializar() {
      this.loading = true;
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.items = [];
      this.palabraBuscada = "";
      HttpHelper.get("TipoIva/Buscar", {
        id: this.itemActivo.Id_TipoIva
      })
        .then(response => {
          this.itemActivo.NombreTipoIva = response.data.Nombre;
        })
        .catch(error => {
          return Promise.reject(error);
        });
      HttpHelper.get("TipoVenta/Buscar", {
        id: this.itemActivo.Id_TipoVenta
      })
        .then(response => {
          this.itemActivo.NombreTipoVenta = response.data.Nombre;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    cargar(valor) {
      if (valor) {
        this.loading = true;
        HttpHelper.get("Cliente", {
          id: valor
        })
          .then(response => {
            this.items.push(response.data);
            this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    listar() {
      if (this.palabraBuscada && this.palabraBuscada.length > 0) {
        this.loading = true;
        HttpHelper.get("Cliente/ListarSelect", {
          palabra: this.palabraBuscada
        })
          .then(response => {
            this.items = response.data;
            if (this.items.length == 1) this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    buscar(id) {
      if (id) {
        var ind = this.items.findIndex(x => x.Id_Cliente == id);
        this.seleccionarItem(this.items[ind]);
      } else this.$emit("seleccionarItem", this.itemVacio);
    },
    seleccionarItem(item) {
      this.itemActivo = item;
      this.buscarSaldoActual();
    },
    buscarSaldoActual() {
      this.loading = true;
      this.itemActivo.SaldoActual = 0;
      if (this.itemActivo.Id_Cliente) {
        HttpHelper.get("Venta/ListarPorCliente", {
          id_Cliente: this.itemActivo.Id_Cliente
        })
          .then(response => {
            this.comprobantes = response.data;
            if (this.comprobantes.length > 0)
              this.itemActivo.SaldoActual = this.comprobantes[0].Saldo;
            this.loading = false;
            this.$emit("seleccionarItem", this.itemActivo);
          })
          .catch(error => {
            return Promise.reject(error);
          });
      } else this.$emit("seleccionarItem", this.itemActivo);
    },
    setearFoco() {
      this.$refs.controlFocoSelectCliente.focus();
    }
  }
};
</script>
